import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import appHistory from "../app/appHistory";
import useIsFirstRender from "./useIsFirstRender";
import useUpdateEffect from "./useUpdateEffect";

const formatParam = (param: string) => _.camelCase(param);

export const useInitialUrlSearchParams = (searchParamsList: string[], hideAfterInit = true) => {
    const location = useLocation();
    const isFirstRender = useIsFirstRender()
    const initialParams = useRef<{[K in typeof searchParamsList[number]]: string}>({});
    const [, setToggleToRerender] = useState(false);

    if (isFirstRender) {
        const result = {};
        const params = new URLSearchParams(location.search);
        searchParamsList.forEach(param => {
            result[formatParam(param)] = params.get(param);
        })
        initialParams.current = result;
    }

    useUpdateEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const result = {};
        searchParamsList.forEach(param => {
            const value = queryParams.get(param);
            const formattedParam = formatParam(param);
            if (value && value !== initialParams.current[formattedParam]) {
                result[formattedParam] = value;
            }
        });
        if (!_.isEmpty(result)) {
            initialParams.current = {
                ...initialParams.current,
                ...result,
            };
            setToggleToRerender(currentState => !currentState);
        }
    }, [location.search]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        let isReplaceHistory = false;
        if (hideAfterInit) {
            searchParamsList.forEach(param => {
                if (queryParams.has(param)) {
                    queryParams.delete(param);
                    isReplaceHistory = true;
                }
            })
        }

        if (isReplaceHistory) {
            appHistory.replace({
                search: queryParams.toString(),
            })
        }
    }, [hideAfterInit, location.search, searchParamsList]);

    return initialParams.current;
}
